<div class="block document-history">
  <h3 class="title">Histórico de Documentos</h3>

  <div class="attachments-wrapper" *ngIf="attachments?.length > 0">
    <div class="attachment-item" *ngFor="let item of attachments | slice: 0 : quantityItems">
      <app-download-attachment [viewModel]="item" (clickItem)="clickAttachment(item)"> </app-download-attachment>
    </div>
  </div>
  <a role="button" tabindex="0" (click)="toggleShowAllDocuments()" *ngIf="attachments?.length > defaultQuantity">
    <i *ngIf="!showAllDocuments" class="icon icon--chevron-bottom icon--small"></i>
    <i *ngIf="showAllDocuments" class="icon icon--chevron-up icon--small"></i>
  </a>
</div>
